<template>
  <div class="header">
    <div class="left">
      <img class="logo" @click="goHome" src="../../assets/img/logo.png" alt />
      <div class="tabs">
        {{$route.path == '/macro' ? '宏观高频模拟和预测库' : '国民经济运行全口径数据库'}}
      </div>
    </div>
    <div class="right">
      <div class="web" @click="goHome">
        <img class="logo" src="../../assets/img/introduce/home.png" alt />
        <span class="webtext">官方网站</span>
      </div>
      <el-button class="login-btn" @click="goLogin">登录</el-button>
      <!-- <el-button class="register-btn">注册</el-button> -->
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixins.js";
export default {
  mixins:[mixin],
  data() {
    return {
      activeName: this.$route.fullPath
    };
  },
  watch: {
    $route() {
      this.activeName = this.$route.fullPath;
    }
  },
  created() {
  },
  methods: {
    handleTabClick(val) {
      this.$router.push(val.name);
    },
    goLogin() {
      this.$route.path == '/macro' ? this.goMacro1('macro') : this.goMacro1('full')
    },
    goHome() {
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 66px;
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  .left {
    display: flex;
    .logo {
      height: 24px;
      cursor: pointer;
    }
    .tabs {
      margin-left: 50px;
      margin-top: 5px;
      color: #6771aa;
    }
  }
  .right {
    display: flex;
    .web {
      margin-right: 100px;
      line-height: 40px;
      cursor: pointer;
      img {
        vertical-align: middle;
        margin-bottom: 6px;
      }
      .webtext {
        margin-left: 10px;
      }
    }
    .login-btn {
      background-color: #1c2d86;
      border-color: #1c2d86;
      color: #fff;
      width: 100px;
    }
    .register-btn {
      background-color: #ffffff;
      border-color: #d8d8d8;
      width: 100px;
    }
  }
}
</style>